import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const serverUrl = () => process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

// Même pattern que ticketApi.js : instance dédiée posant son propre header
// Authorization depuis le cookie, indépendamment de l'intercepteur global.
const client = axios.create();
client.interceptors.request.use((config) => {
    const token = cookies.get('DASHBOARD_ACCESS');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export async function getDemoSites() {
    const { data } = await client.get(`${serverUrl()}/api/demo-sites`);
    return data;
}
